import React, { Fragment } from 'react'

// icons
import { faBarcode } from '@fortawesome/free-solid-svg-icons'

// styles
import './Articulos.css'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemArticulo from './ItemArticulo'

// route
import { withRouter } from 'react-router-dom'
import routes from '../../Routes'

import HeaderActionsButtons from '../Custom/HeaderActionsButtons'
import HeaderPagination from '../Custom/HeaderPagination'
import usePagination from './hooks/usePagination'
import useArticle from './hooks/useArticle'

const visibleButtons = {
  create: true,
  composite: true,
  import: true,
  export: true,
  deleted: true,
  search: true,
}

function Articulos({ history }) {
  const {
    articulos,
    setIsLoad,
    page,
    totalRegister,
    totalPage,
    handleBuscador,
    nextPage,
    previousPage,
    searchCriteria,
    setSearchCriteria,
    getCriteriaLabel,
  } = usePagination(history, true)

  const { handleImprimir } = useArticle()

  return (
    <Fragment>
      <Header />
      <div className="container-fluid mt-3">
        <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
          <BotonBack />
          <Subtitulo icon={faBarcode} title={'Articulos'} />
        </div>

        <HeaderActionsButtons
          history={history}
          routes={routes.ARTICULO}
          visibleButtons={visibleButtons}
          handleImprimir={handleImprimir}
          handleBuscador={handleBuscador}
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
          getCriteriaLabel={getCriteriaLabel}
        />

        <HeaderPagination
          page={page}
          totalPage={totalPage}
          previousPage={previousPage}
          nextPage={nextPage}
          totalRegister={totalRegister}
        />

        <table className="table table-striped mt-3 text-center">
          <thead>
            <tr>
              <th scope="col">Codigo</th>
              <th scope="col">Nombre</th>
              <th scope="col">Pesable</th>
              <th scope="col">Balanza</th>
              <th scope="col">Compuesto</th>
              <th scope="col">Costo</th>
              <th scope="col">Precio Final</th>
              <th scope="col">Ganancia</th>
              <th scope="col">Familia</th>
              <th scope="col">Marca</th>
              <th scope="col">Unidad Medida</th>
              <th scope="col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {articulos.map((articulo) => (
              <ItemArticulo
                key={parseInt(articulo.id, 10)}
                setIsLoad={setIsLoad}
                articulo={articulo}
              />
            ))}
          </tbody>
        </table>
      </div>
    </Fragment>
  )
}

export default withRouter(Articulos)
